
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AccountService} from "../../../services";
import {environment} from "../../../../../environments/environment";
import {Orders} from "../../../models/orders";
import {Gallery} from "../model/gallery";
import {Galleries} from "../model/galleries";



@Injectable({ providedIn: 'root' })
export class GalleryService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number) {
        let filtersString = '';


        return this.http.get<Galleries>(`${environment.apiEndpoint}/v1/cms/galleries?offset=`+offset+`&limit=`+limit + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<Gallery>(`${environment.apiEndpoint}/v1/cms/galleries/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getByObject(id: string, type: string) {
        return this.http.get<Gallery>(`${environment.apiEndpoint}/v1/cms/galleries/${id}/type/${type}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getImageById(galleryId: string, imageId: string) {
        return this.http.get<string>(`${environment.apiEndpoint}/v1/cms/galleries/image/${galleryId}/${imageId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/cms/galleries/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    updateItem(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/cms/galleries/items/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    removeItem(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/cms/galleries/items/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/cms/galleries`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    uploadFile(formData) {
        return this.http.post(`${environment.apiEndpoint}/v1/cms/galleries/upload`, formData, {
            headers: new HttpHeaders({
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + this.accountService.userValue.token,
                }
            ),
            reportProgress: true,
            observe: 'events'
        });
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/cms/gallery/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

}
